// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PromptListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetPromptsByAufgabeInbound(): (
  aufgabeId: string
) => Promise<PromptListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId) =>
      (await getAPI()).prompts.getPromptsByAufgabeInbound({ aufgabeId }),
    [getAPI]
  );
}
